
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/at_cliente_faq",
      function () {
        return require("private-next-pages/at_cliente_faq/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/at_cliente_faq"])
      });
    }
  